<template>
  <div class="loading">
    <span></span>
    <span></span>
    <span></span>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="stylus" scoped>
.loading
  position absolute
  top -25px
  left  50%
  -webkit-transform translateY(-50%) translateX(-50%)
  -moz-transform translateY(-50%) translateX(-50%)
  -o-transform translateY(-50%) translateX(-50%)
  transform translateY(-50%) translateX(-50%)


  span
    display block
    background #0b1547
    width 100px
    height 5px
    margin-top 5px
    animation load 2s infinite
    border-radius 5px

    for num in (2..3)
      &:nth-child({num}){
        animation-delay (num * 100)ms
      }

  @keyframes load{
    50%{
      width 5px
      margin-right 95px
      opacity .1
    }
  }
</style>
